import Joi from 'joi';
import PropTypes from 'prop-types';

import Form from '../../common/form';
import toastService from '../../../services/toastService';

class ReportConclusionForm extends Form {
	state = {
		data: {
			recommendations: '',
			conclusion: '',
			limitations: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		recommendations: Joi.string().min(5).required().label('Recommendations'),
		conclusion: Joi.string().min(5).required().label('Conclusion'),
		limitations: Joi.string().allow('').optional().label('Limitations'),
	};

	static propTypes = {
		initialRecommendations: PropTypes.string,
		initialConclusion: PropTypes.string,
		initialLimitations: PropTypes.string,
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		this.props.onProceed({
			recommendations: this.state.data.recommendations,
			conclusion: this.state.data.conclusion,
			limitations: this.state.data.limitations,
		});

		toastService.success('Recommendations, Conclusion & Limitations updated successfully!.');
	};

	componentDidMount() {
		this.setState({
			data: {
				recommendations: this.props.initialRecommendations ?? '',
				conclusion: this.props.initialConclusion ?? '',
				limitations: this.props.initialLimitations ?? '',
			},
		});
	}

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				{this.renderTextEditor({
					name: 'recommendations',
					label: 'Recommendations',
					placeholder: 'Enter the recommendations for this report',
				})}

				<div className="my-4 divider"></div>

				{this.renderTextEditor({
					name: 'conclusion',
					label: 'Conclusion',
					placeholder: 'Enter the conclusion for this report',
				})}

				<div className="my-4 divider"></div>

				{this.renderTextEditor({
					name: 'limitations',
					label: 'Limitations',
					placeholder: 'Enter any limitations for this report (if any)',
				})}

				<div className="my-4 divider"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save Recommendations, Conclusion & Limitations')}
				</div>
			</form>
		);
	}
}

export default ReportConclusionForm;
